import React from 'react';
import type { Ad } from '../../types';
import styles from './MobileLargeFeaturedCard.module.css';

interface MobileLargeFeaturedCardProps {
  ad: Ad;
  onClick: () => void;
}

export const MobileLargeFeaturedCard: React.FC<MobileLargeFeaturedCardProps> = ({ ad, onClick }) => {
  const imageUrl = ad.imageUrls?.[0] || null;
  const hasImage = imageUrl !== null;

  const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={styles.card}
      onClick={onClick}
      onKeyPress={handleKeyPress}
      role="button"
      tabIndex={0}
      aria-label={`View ${ad.title}`}
    >
      <div className={styles.imageContainer}>
        {hasImage ? (
          <img
            src={imageUrl}
            alt={ad.title}
            className={styles.image}
          />
        ) : (
          <span className={styles.placeholder} aria-hidden="true">🚗</span>
        )}
        <div className={styles.featuredLabel}>精選</div>
      </div>
    </div>
  );
};
